import React, { useState, useRef, useEffect } from "react"
import ReactDOM from "react-dom"

export const FilterCell = ({ options }) => {
   const { title, filterValue, filterConstants, onFilterSelect } = options
   const [open, setOpen] = useState(false)
   const [position, setPosition] = useState({ top: 0, left: 0 })
   const toggleRef = useRef()

   const handleMenuToggle = () => {
      setOpen(prev => !prev)
   }

   const handleItemSelect = value => {
      onFilterSelect(value)
      setOpen(false)
   }

   useEffect(() => {
      if (open && toggleRef.current) {
         const rect = toggleRef.current.getBoundingClientRect()
         setPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
         })
      }
   }, [open])

   return (
      <div className="table-filter-dropdown-menu-con">
         <div
            ref={toggleRef}
            onClick={handleMenuToggle}
            className="data-table-head sortable"
         >
            <span className="column-title">{title}</span>
            {(filterValue || filterValue === 0) && (
               <span className="filter-value">
                  ({filterConstants.getDisplayTextKey(filterValue)})
               </span>
            )}
            <i className="bx bx-chevron-down"></i>
         </div>

         {open &&
            ReactDOM.createPortal(
               <div
                  className="custom-dropdown-menu show"
                  style={{
                     position: "absolute",
                     top: "200px !important",
                     left: position.left,
                     zIndex: 1000,
                     background: "white",
                     border: "1px solid #ccc",
                     boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
                  }}
               >
                  <div
                     className={`dropdown-item ${
                        !filterValue && filterValue !== 0 ? "active" : ""
                     }`}
                     onClick={() => handleItemSelect(null)}
                  >
                     All
                  </div>
                  {!!Object.keys(filterConstants).length &&
                     Object.keys(filterConstants).map((key, index) => (
                        <div
                           key={index}
                           className={`dropdown-item ${
                              filterValue === filterConstants[key]
                                 ? "active"
                                 : ""
                           }`}
                           onClick={() =>
                              handleItemSelect(filterConstants[key])
                           }
                        >
                           {filterConstants.getDisplayTextKey(
                              filterConstants[key]
                           )}
                        </div>
                     ))}
               </div>,
               document.body
            )}
      </div>
   )
}
